function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.6 14c-.3 0-.5-.1-.7-.3L.6 8.4c-.8-.8-.8-2 0-2.8L5.9.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L2 7l5.3 5.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14"
  }, props), _ref);
};

export default SvgComponent;